/* eslint-disable complexity */
import {
  getLocalWeekdayTranslation,
  getWeekdayOccurrenceStringFromTerminWeekdayOccurrence,
  IndividuelleWiederholung,
  TerminWiederholungsIntervall,
  TerminWochentage,
} from '@/domain/termine/shared/types';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

type IndividuelleWdhProps = {
  wiederholung: IndividuelleWiederholung | null | undefined;
  wiederholungBis?: string | null;
  datum: string;
};

export function IndividuellerWiederholungsText({
  wiederholung,
  wiederholungBis,
  datum,
}: IndividuelleWdhProps) {
  const { t } = useTranslation();

  const sortedWeekDays = Object.values(TerminWochentage);
  console.log(sortedWeekDays);

  const weekDays = wiederholung?.wochentage
    ? wiederholung?.wochentage
        .sort((a, b) => sortedWeekDays.indexOf(a) - sortedWeekDays.indexOf(b))
        .map((tag) => getLocalWeekdayTranslation(tag) + '.')
        .join(', ')
    : '';

  const formatWdhBis = wiederholungBis
    ? dayjs(wiederholungBis).format('DD.MM.YYYY')
    : '';

  let text = '';
  const lowerCase = true;

  switch (wiederholung?.wiederholungsIntervall) {
    case TerminWiederholungsIntervall.WOCHE:
      text = t('domain.termine.individuelleWiederholung.week', {
        count: wiederholung?.occurrenceCount,
        weekday: weekDays,
      });
      break;
    case TerminWiederholungsIntervall.TAG:
      text = t('domain.termine.individuelleWiederholung.day', {
        count: wiederholung?.occurrenceCount,
      });
      break;
    case TerminWiederholungsIntervall.MONAT:
      text = t('domain.termine.individuelleWiederholung.month', {
        count: wiederholung.occurrenceCount,
        weekdayOccurence: getWeekdayOccurrenceStringFromTerminWeekdayOccurrence(
          wiederholung.weekDayOccurrence,
          datum,
          wiederholung?.wiederholungsIntervall,
          lowerCase,
        ),
      });
      break;
    case TerminWiederholungsIntervall.JAHR:
      text = t('domain.termine.individuelleWiederholung.year', {
        count: wiederholung.occurrenceCount,
        weekdayOccurence: getWeekdayOccurrenceStringFromTerminWeekdayOccurrence(
          wiederholung.weekDayOccurrence,
          datum,
          wiederholung?.wiederholungsIntervall,
          lowerCase,
        ),
      });
      break;
  }
  if (wiederholungBis) {
    text += t('domain.termine.individuelleWiederholung.bis', {
      endDate: formatWdhBis,
    });
  }
  return <div className="whitespace-break-spaces text-start">{text}</div>;
}
